import React, { useState } from 'react'
import { XMarkIcon, CalendarIcon, ChatBubbleOvalLeftEllipsisIcon } from '@heroicons/react/24/outline';
import { UserAuth } from '../App';
import AlertBox from '../components/AlertBox';
import { Toaster } from 'react-hot-toast';
import { database } from "../config/firebaseConfig";
import { collection, getDocs, updateDoc, doc, addDoc, increment } from "firebase/firestore";
import { LazyLoadImage } from "react-lazy-load-image-component";

function NewsCard(props) {
  const SUCCESS = "success"
  const WARNING = "warning"
  const DANGER = "danger"

  const [newsIdSelected, setNewsIdSelected] = useState("");
  const [userComment, setUserComment] = useState("");
  
  const [selectedNewsComments, setSelectedNewsComments] = useState(null);

  const {user} = UserAuth();

  const togglePopupReadMore = (newsId) => {
    [].forEach.bind(document.getElementsByClassName(`popup_readmore ${newsId}`),function(itm){
      itm.style.display = "flex";
    })();
    setNewsIdSelected(newsId);
    getNewsComments(newsId)
  }

  const closePopupReadMore = (newsId) => {
    [].forEach.bind(document.getElementsByClassName(`popup_readmore ${newsId}`),function(itm){
        itm.style.display = "none";
    })();
    setNewsIdSelected("");
    setUserComment("");
    setSelectedNewsComments(null);
  }

  async function sendComment(newsId) {

    if (user === null) {
      console.log("Usuario no identificado")
      AlertBox(DANGER, '¡Debe iniciar sesión o registrarse para dejar un comentario!');
      return;

    } else if (userComment === "") {
      AlertBox(WARNING, '¡Debe ingresar un comentario!');
      return;

    }

    const newsCommentsRef = collection(database, 'news', newsIdSelected, 'comments');
    await addDoc(newsCommentsRef, {userName:user.name, comment: userComment})
    increaseCommentsCounter(newsIdSelected, 1);
    AlertBox(SUCCESS, 'Comentario agregado exitosamente');
    
    setUserComment("");
    getNewsComments(newsId)
  }

  async function getNewsComments(newsId) {
    const commentsCollectionRef = collection(database, "news", newsId, "comments");
    const comments = await getDocs(commentsCollectionRef);
    setSelectedNewsComments(comments.docs.map((doc) => ({...doc.data(), id: doc.id})));

  }

  async function increaseCommentsCounter(newsId, counter) {
    const newsCollectionRef = doc(database, "news", newsId);
    await updateDoc(newsCollectionRef, {countComments: increment(counter)});
  }

  return (
    <div>

        <div>
          <Toaster
          toastOptions={{
          duration:3000,
          }}/>
        </div>

        {props.allNews? props.allNews.map((news, index) => {
          if (index % 2 === 0) {
            return (
            <div key={index}>
              
              <div className='hidden sm:w-full sm:h-96 sm:bg-white sm:my-6 sm:py-2 sm:flex sm:justify-start sm:items-stretch'>
            
                <div className='group hover:drop-shadow-shad h-full w-full flex flex-row max-w-6xl mx-10'>
      
                  <div className='w-2/3 h-full flex flex-col justify-center bg-news-card pl-10 pt-3 pb-3 pr-3 col-start-1 col-end-3'>
            
                    <h2 className='text-justify font-semibold mb-3'>{news.title}</h2>
      
                    <span className='w-48 h-1 bg-primary-100 border border-primary-100 mb-8'></span>
      
                    <p className='text-sm text-justify pr-8 mb-12 overflow-hidden'>{news.description}</p>
                    
                    <button className='h-6 w-24 mt-10 text-sm bg-primary-100 text-white rounded font-medium hover:bg-primary-200'
                          onClick={() => {togglePopupReadMore(news.id);}}>Leer más</button>
      
                  </div>

                  <div className='w-1/3 h-full max-h-96 relative'>

                    <div className='bg-slate-600'>
                      <LazyLoadImage className='absolute object-cover w-full h-full'
                        src={news.image}
                        alt='Imagen prueba'></LazyLoadImage>
                    </div>

                    <div className='absolute inset-0 opacity-0 group-hover:opacity-100 group-hover:bg-news-hover transition delay-75 flex text-center items-center justify-center'>

                      <div className='flex flex-col space-y-10'>

                        <div className='flex flex-row space-x-5'>

                          <CalendarIcon className='text-white w-10 h-10'/>
                          <p className='text-white opacity-100 mt-2'>{news.date}</p>

                        </div>

                        <div className='flex flex-row space-x-5'>

                          <ChatBubbleOvalLeftEllipsisIcon className='text-white w-10 h-10'/>
                          <p className='text-white opacity-100 mt-2'>{news.countComments}</p>

                        </div>

                      </div>

                    </div>

                  </div>

                </div>

              </div>

              <div className='sm:hidden w-full h-full bg-white my-6 py-2 flex place-content-center'>

                <div className='w-full h-full max-h-96 max-w-xs sm:max-w-md flex flex-col bg-news-card space-y-2 pb-2 items-center'>
                  
                  <div className='w-full h-full bg-slate-600'>
                    <LazyLoadImage className='object-cover w-full h-full max-h-52' 
                    src={news.image}
                    alt='Imagen prueba'></LazyLoadImage>
                  </div>
                  
                  <div className='w-full'>
                    <h2 className='text-center font-semibold'>{news.title}</h2>
                  </div>

                  <span className='w-48 h-1 bg-primary-100 border border-primary-100'></span>

                  <div className='p-2 w-full h-full overflow-y-auto'>
                      <p className='text-sm text-center'>{news.description}</p>
                  </div>

                  <button className='h-6 w-24 text-sm bg-primary-100 text-white rounded font-medium hover:bg-primary-200'
                          onClick={() => {togglePopupReadMore(news.id);}}>Leer más</button>

                </div>

              </div>

              <div className={`hidden popup_readmore ${news.id} pt-8 pb-8 fixed backdrop-blur-sm mt-navbar-mobile bg-popup inset-0 z-30 items-center justify-center`}>

                <div className='relative w-4/5 sm:w-form1 flex flex-col pb-8 mx-10 h-full bg-white rounded overflow-y-auto max-h-popup-mobile max-w-table-web'>

                    <button className='absolute top-1 right-1 hover:text-primary-100 bg-white opacity-90 rounded-full' onClick={() => {closePopupReadMore(news.id);}}><XMarkIcon className='w-8 h-8 md:w-10 md:h-10'/></button>

                    <div className='w-full h-56 sm:h-80 items-center bg-slate-600'>
                        <LazyLoadImage
                            className='w-full h-full object-cover'
                            src={news.image}
                            alt='Imagen Noticia'>
                        </LazyLoadImage>
                    </div>

                    <div className='w-full flex flex-row px-4 py-4 space-x-2'>
                        <h2 className='text-xl lg:text-xl font-bold'>{news.title}</h2>
                        <CalendarIcon className='mt-1 text-zinc-600 w-5 h-5'/>
                        <h2 className='mt-1 text-sm text-zinc-600 lg:text-base'>{news.date}</h2>
                    </div>

                    <div className='w-full px-4'>
                        <p readOnly className='overflow-auto resize-none w-full whitespace-pre-line'>{news.description}</p>
                    </div>

                    {/* Código para comentarios */}
                    <div className='w-full px-4 py-5 flex flex-col'>
                      <h2 className='text-justify font-semibold text-gray-comments'>Comentarios</h2>
                      <span className='w-full border border-gray-span'></span>
                    </div>

                    <div className='w-full px-4 flex flex-row space-x-5 items-center justify-center'>

                      <div className='w-full flex flex-col justify-center items-center space-y-2'>

                        <textarea className="px-2 py-1 md:text-base rounded-xl h-text-area-height w-full lg:h-30 text-sm text-input-font bg-background
                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none border-none"
                            onChange={(ev) => {setUserComment(ev.target.value)}} value={userComment}
                            id="description" name="description" rows="7" cols="41" placeholder='Ingrese su comentario...'></textarea>

                        <button className='sm:hidden h-8 w-80 text-sm bg-primary-100 text-white rounded font-medium hover:bg-primary-200'
                                                    onClick={() => {sendComment(news.id);}}>Enviar</button>

                      </div>

                      <div className='hidden sm:flex'>
                        <button className='h-12 w-24 text-sm bg-primary-100 text-white rounded font-medium hover:bg-primary-200'
                              onClick={() => {sendComment(news.id);}}>Enviar</button>
                      </div>


                    </div>

                    {selectedNewsComments?.map((comment, index) => (
                      <div className='mt-10 w-full flex flex-row pr-6 justify-start items-center relative' key={index}>
                        
                        <div className="w-10 overflow-hidden inline-block">
                          <div className="h-16 bg-primary-300 -rotate-45 transform origin-top-right"></div>
                        </div>

                        <div className='bg-primary-300 w-full h-24 flex flex-col justify-center items-start px-10'>
                          <h3 className='text-justify text-black text-sm lg:text-lg'>{comment.comment}</h3>
                          <h3 className='text-comment-autor text-sm lg:text-lg'>{comment.userName}</h3>
                        </div>

                      </div>
                    ))}
                    {/* Cierra comentarios */}
                </div>

              </div>

            </div>
            
            );

          } return (
            <div key={index}>

              <div className='hidden sm:w-full sm:h-96 sm:bg-white sm:my-6 sm:py-2 sm:flex sm:justify-end sm:items-stretch'>
              
                <div className='group hover:drop-shadow-shad h-full w-full flex flex-row max-w-6xl mx-10'>
      
                  <div className='w-1/3 h-full max-h-96 relative'>

                    <div className='bg-slate-600'>
                    <LazyLoadImage className='absolute object-cover w-full h-full' 
                      src={news.image}
                      alt='Imagen Noticia'></LazyLoadImage>

                    </div>
                    
                    <div className='absolute inset-0 opacity-0 group-hover:opacity-100 group-hover:bg-news-hover transition delay-75 text-center flex items-center justify-center'>

                      <div className='flex flex-col space-y-10'>

                        <div className='flex flex-row space-x-5'>

                          <CalendarIcon className='text-white w-10 h-10'/>
                          <p className='text-white opacity-100 mt-2'>{news.date}</p>

                        </div>

                        <div className='flex flex-row space-x-5'>

                          <ChatBubbleOvalLeftEllipsisIcon className='text-white w-10 h-10'/>
                          <p className='text-white opacity-100 mt-2'>{news.countComments}</p>

                        </div>

                      </div>

                    </div>

                  </div>
      
                  <div className='w-2/3 h-full max-h-96 flex flex-col justify-center bg-news-card pl-10 pt-3 pb-3 pr-3 col-start-1 col-end-3'>
            
                    <h2 className='text-justify font-semibold mb-3'>{news.title}</h2>
      
                    <span className='w-48 h-1 bg-primary-100 border border-primary-100 mb-8'></span>
      
                    <p className='text-sm text-justify pr-8 mb-12'>{news.description}</p>
                    
                    <button className='h-6 w-24 mt-10 text-sm bg-primary-100 text-white rounded font-medium hover:bg-primary-200'
                          onClick={() => {togglePopupReadMore(news.id);}}>Leer más</button>
      
                  </div>
      
                </div>
      
              </div>

              <div className='sm:hidden w-full h-full bg-white my-6 py-2 flex place-content-center'>

                <div className='w-full max-h-96 md: h-full max-w-xs sm:max-w-md flex flex-col bg-news-card space-y-2 pb-2 items-center'>  
                  
                  <div className='w-full h-full max bg-slate-600'>
                    <LazyLoadImage className='object-cover w-full h-full max-h-52' 
                    src={news.image}
                    alt='Imagen prueba'></LazyLoadImage>
                  </div>
                  
                  <div className='w-full'>
                    <h2 className='text-center font-semibold'>{news.title}</h2>
                  </div>

                  <span className='w-48 h-1 bg-primary-100 border border-primary-100'></span>

                  <div className='p-2 w-full h-full overflow-y-auto'>
                      <p className='text-sm text-center'>{news.description}</p>
                  </div>

                  <button className='h-6 w-24 text-sm bg-primary-100 text-white rounded font-medium hover:bg-primary-200'
                          onClick={() => {togglePopupReadMore(news.id);}}>Leer más</button>

                </div>

              </div>

              <div className={`hidden popup_readmore ${news.id} pt-8 pb-8 fixed backdrop-blur-sm mt-navbar-mobile bg-popup inset-0 z-30 items-center justify-center`}>

              <div className='relative w-4/5 sm:w-form1 flex flex-col pb-8 mx-10 h-full bg-white rounded overflow-y-auto max-h-popup-mobile max-w-table-web'>

              <button className='absolute top-1 right-1 hover:text-primary-100 bg-white opacity-90 rounded-full' onClick={() => {closePopupReadMore(news.id);}}><XMarkIcon className='w-8 h-8 md:w-10 md:h-10'/></button>

                    <div className='w-full h-56 sm:h-80 items-center bg-slate-600'>
                        <LazyLoadImage
                            className='w-full h-full object-cover object-top'
                            src={news.image}
                            alt='Imagen Noticia'>
                        </LazyLoadImage>
                    </div>

                    <div className='w-full flex flex-row px-3 py-4 space-x-2'>
                        <h2 className='text-xl lg:text-xl font-bold'>{news.title}</h2>
                        <CalendarIcon className='mt-1 text-zinc-600 w-5 h-5'/>
                        <h2 className='mt-1 text-sm text-zinc-600 lg:text-base'>{news.date}</h2>
                    </div>

                    <div className='w-full px-4'>
                        <p readOnly className='overflow-auto resize-none w-full whitespace-pre-line'>{news.description}</p>
                        
                    </div>

                    <div className='w-full px-4 py-5 flex flex-col'>
                      <h2 className='text-justify font-semibold text-gray-comments'>Comentarios</h2>
                      <span className='w-full border border-gray-span'></span>
                    </div>

                    <div className='w-full px-4 flex flex-row space-x-5 items-center justify-center'>

                      <div className='w-full flex flex-col justify-center items-center space-y-2'>

                        <textarea className="px-2 py-1 md:text-base rounded-xl h-text-area-height w-full lg:h-30 text-sm text-input-font bg-background
                            focus:outline-none focus:border focus:border-primary-100 focus:shadow-md resize-none border-none"
                            onChange={(ev) => {setUserComment(ev.target.value)}} value={userComment}
                            id="description" name="description" rows="7" cols="41" placeholder='Ingrese su comentario...'></textarea>

                        <button className='sm:hidden h-8 w-80 text-sm bg-primary-100 text-white rounded font-medium hover:bg-primary-200'
                                                    onClick={() => {sendComment(news.id);}}>Enviar</button>

                      </div>

                      <div className='hidden sm:flex'>
                        <button className='h-12 w-24 text-sm bg-primary-100 text-white rounded font-medium hover:bg-primary-200'
                              onClick={() => {sendComment(news.id);}}>Enviar</button>
                      </div>


                    </div>

                    {selectedNewsComments?.map((comment, index) => (
                      <div className='mt-10 w-full flex flex-row pr-6 justify-start items-center relative' key={index}>
                        
                        <div className="w-10 overflow-hidden inline-block">
                          <div className="h-16 bg-primary-300 -rotate-45 transform origin-top-right"></div>
                        </div>

                        <div className='bg-primary-300 w-full h-24 flex flex-col justify-center items-start px-10'>
                          <h3 className='text-justify text-black text-sm lg:text-lg'>{comment.comment}</h3>
                          <h3 className='text-comment-autor text-sm lg:text-lg'>{comment.userName}</h3>
                        </div>

                      </div>
                    ))}

                </div>

              </div>

            </div>
            )
          })
          :
          <div className='w-full bg-white flex h-auto justify-center items-center text-4xl text-primary-100 space-x-1 min-h-[80vh]'>
              <svg fill='none' className="w-14 h-14 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                  <path clipRule='evenodd'
                      d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                      fill='currentColor' fillRule='evenodd' />
              </svg>
              <div>
                  Cargando...
              </div>
          </div>
        }
    </div>
  )
}

export default NewsCard;